import { useCallback, useContext, useEffect, useState } from 'react';
import { SupervisorApi } from '@api';
import { SupervisorContext } from '@/contexts/SupervisorContext';

/**
 * Vad som kräver handledarens uppmärksamhet, per brukare.
 *
 * I dag är det stjärnvärdesförslag: ett barn eller en tonåring har skapat en aktivitet
 * och begärt stjärnor för den, och tills handledaren svarar ger aktiviteten INGA
 * stjärnor. Den väntan är osynlig för brukaren, så den måste synas för handledaren —
 * och redan i klientlistan, inte först efter att man valt någon.
 *
 * EN förfrågan för hela listan (backend räknar per brukare i en fråga), inte en per
 * kort. Läses om när fliken blir synlig igen: handledaren svarar ofta i en annan vy
 * och ska inte mötas av en markering som redan är åtgärdad.
 */
export const useClientAttention = (): Record<string, number> => {
  const { isSupervising } = useContext(SupervisorContext);
  const [counts, setCounts] = useState<Record<string, number>>({});

  const load = useCallback(async () => {
    if (!isSupervising) {
      setCounts({});
      return;
    }
    setCounts(await new SupervisorApi().getAttention());
  }, [isSupervising]);

  useEffect(() => {
    void load();

    const handleVisibility = () => {
      if (document.visibilityState === 'visible') void load();
    };
    document.addEventListener('visibilitychange', handleVisibility);
    return () => document.removeEventListener('visibilitychange', handleVisibility);
  }, [load]);

  return counts;
};
